module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/4x2-flatpack-mobile-fb1c1023a67335bf04167dd4358f279f.png";